import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
// import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NavbarComponent } from './navbar/navbar.component';
import { HomeComponent } from './home/home.component';
import { FooterComponent } from './footer/footer.component';
import { AboutusComponent } from './aboutus/aboutus.component';
import { LoginComponent } from './modals/login/login.component';
import { NgbCollapseModule, NgbModule, NgbRatingModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { DemoComponent } from './modals/demo/demo.component';
import { TermsConditionsComponent } from './terms-conditions/terms-conditions.component';
import { PrivacyComponent } from './privacy/privacy.component';
import { TitleService } from './shared/title.service';
import { NgbAccordionModule } from '@ng-bootstrap/ng-bootstrap';
import { NgbPanel } from '@ng-bootstrap/ng-bootstrap';
import { NgbCarouselModule } from '@ng-bootstrap/ng-bootstrap';
import { ContactCardComponent } from './contact-card/contact-card.component';
import { CareersComponent } from './careers/careers.component';
import { TestimonialCardComponent } from './testimonial-card/testimonial-card.component';
import { ClientMarqueeComponent } from './client-marquee/client-marquee.component';
import { UspComponent } from './products/usp/usp.component';
import { InfrastructureBannerComponent } from './infrastructure-banner/infrastructure-banner.component';
import { TeamMembersComponent } from './team-members/team-members.component';
import { SecurityComponent } from './security/security.component';
import { BoardComponent } from './board/board.component';
import { ProductJourneyComponent } from './product-journey/product-journey.component';
import { Cards } from './models/Cards';
import { ProductListingComponent } from './product-listing/product-listing.component';
import { SendUpdatesComponent } from './send-updates/send-updates.component';
import { ContactUsComponent } from './contact-us/contact-us.component';
import { SendInfoBannerComponent } from './send-info-banner/send-info-banner.component';
import { NgxUsefulSwiperModule } from 'ngx-useful-swiper';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ProductListComponent } from './product-list/product-list.component';
import { CareerModalComponent } from './modals/career-modal/career-modal.component';
import { NgOptimizedImage } from '@angular/common';
import { PatientLoginComponent } from './modals/patient-login/patient-login.component';
import { ContainerComponent } from './patient-portal-setup/@layout/container/container.component'
import { AuthGuardService } from './shared/auth/auth-gaurd.service';
import { NbAuthModule } from '@nebular/auth';
import { NgSelectModule } from '@ng-select/ng-select';
import { 
  NbThemeModule, 
  NbLayoutModule,  
  NbUserModule,
  NbMenuService,
  NbContextMenuModule,
  NbMenuModule,
  NbSidebarModule,
  NbSidebarService 
} from '@nebular/theme';
import { OAuthModule } from 'angular-oauth2-oidc';

const appRoutes: Routes = [
  {
    path: 'about-us', 
    component: AboutusComponent,
    data: {title: '- About us'}
  },
  {
    path: 'careers', 
    component: CareersComponent,
    data: {title: '- Careers'}
  },
  {
    path: 'terms', 
    component: TermsConditionsComponent,
    data: {title: '- Terms and Conditions'}
  },
  {
    path: 'security', 
    component: SecurityComponent,
    data: {title: '- Security'}
  },
  {
    path: 'board', 
    component: BoardComponent,
    data: {title: '- Board & Investors'}
  },
  {
    path: 'privacy-policy', 
    component: PrivacyComponent,
    data: {title: '- Privacy Policy'}
  },
  {
    path: 'product/journey', 
    component: ProductJourneyComponent,
    data: {title: '- Customize Your Journey'}
  },
  {
    path: 'product/list', 
    component: ProductListComponent,
    data: {title: '- See Our Offerings'}
  },
  {
    path: 'product/usp',
    component: UspComponent,
    data: {title: '- Product USPs'}
  },
  {
    path: 'contact-us',
    component: ContactUsComponent,
    data: {title: '- Contact Us'}
  },
  {
    path: '',
    component: HomeComponent,
    data: {title: '– Best Hospital Management Software in India | More Than HMS, HIS & Hospital Software'}
  },
  {
    path: "patient-login",
    component: PatientLoginComponent,
    data: {title: "- Patient Login"}
  },
  {
    path: "patient-portal",
    loadChildren:  () => import('./patient-portal-setup/patient-portal/patient-portal.module').then(m => m.PatientPortalModule),
    component: ContainerComponent,
    canActivateChild: [AuthGuardService],
    canActivate: [AuthGuardService]
  },{
    path: "form",
    loadChildren: () => import('./consent-approval/consent-approval.module').then(m => m.ConsentApprovalModule),
  },{
    path: "demo",
    component: DemoComponent
  },
  {
    path: '',
    redirectTo: '/',
    pathMatch: 'full'
  }, {
    path: '**',
    redirectTo: '/',
    pathMatch: 'full'
  }

]
@NgModule({
  declarations: [
    AppComponent,
    NavbarComponent,
    HomeComponent,
    FooterComponent,
    AboutusComponent,
    LoginComponent,
    DemoComponent,
    TermsConditionsComponent,
    PrivacyComponent,
    ContactCardComponent,
    CareersComponent,
    TestimonialCardComponent,
    ClientMarqueeComponent,
    UspComponent,
    InfrastructureBannerComponent,
    TeamMembersComponent,
    SecurityComponent,
    BoardComponent,
    ProductJourneyComponent,
    ProductListingComponent,
    SendUpdatesComponent,
    ContactUsComponent,
    SendInfoBannerComponent,
    ProductListComponent,
    CareerModalComponent,
    PatientLoginComponent,
    ContainerComponent
  ],
  imports: [
    BrowserModule,
    RouterModule.forRoot(
      appRoutes,
      { scrollPositionRestoration: 'enabled', anchorScrolling: 'enabled' }
    ),
    NgbModule,
    FormsModule,
    HttpClientModule,
    NgbAccordionModule,
    NgbPanel,
    NgbCarouselModule,
    NgbRatingModule,
    NgbCollapseModule,
    NgxUsefulSwiperModule,
    BrowserAnimationsModule,
    NgOptimizedImage,
    NbLayoutModule,
    NbAuthModule.forRoot(),
    NbThemeModule.forRoot({ name: 'default' }),
    NbSidebarModule,
    NbUserModule,
    NbContextMenuModule,
    NbMenuModule.forRoot(),
    NgSelectModule,
    OAuthModule.forRoot()
  ],
  providers: [TitleService, Cards, NbSidebarService, NbMenuService, AuthGuardService],
  bootstrap: [AppComponent]
})
export class AppModule {   constructor(titleService: TitleService) {
  titleService.init();
} }
